import classNames from "classnames";
import { ForwardedRef, forwardRef, ReactNode } from "react";
import {
  BottomSheet,
  BottomSheetProps,
  BottomSheetRef,
} from "react-spring-bottom-sheet";
import { ScrollIndicatorContainer } from "@livingmap/hippo";

import styles from "./Sheet.module.scss";
import "react-spring-bottom-sheet/dist/style.css";

interface Props {
  dataQA: string;
  children: ReactNode;
}

const Sheet = forwardRef(function Sheet(
  { children, dataQA, className, ...props }: Props & BottomSheetProps,
  ref: ForwardedRef<BottomSheetRef>,
) {
  return (
    <BottomSheet
      blocking={false}
      data-qa={dataQA}
      {...props}
      ref={ref}
      className={classNames(styles.root, className)}
    >
      <ScrollIndicatorContainer
        dataQA={`${dataQA}-scroll-indicator`}
        className={styles.scrollIndicator}
        contentClassName={styles.content}
        style={{ height: "100%" }}
      >
        {children}
      </ScrollIndicatorContainer>
    </BottomSheet>
  );
});

export default Sheet;
